import { store } from "../../..";
import { API } from "../../../../legacy/api";
import { showError } from "../../../utils/errorHandler";
import * as actions from "./Footer.actions";

API.on("clock.available.set", (available: boolean) => {
  if (typeof available === "boolean") {
    store.dispatch(actions.setClockAvailable(available));
  } else {
    showError(
      "Set clock available has to be a boolean: " + typeof available + " given."
    );
  }
});

API.on("clock.date.set", (date: Date) => {
  if (date instanceof Date) {
    store.dispatch(actions.setClockDate(date));
  } else {
    showError("Set clock date has to be a date");
  }
});
